import { render, staticRenderFns } from "./NewsCatalogBlock.vue?vue&type=template&id=51800e10&scoped=true&"
import script from "./NewsCatalogBlock.vue?vue&type=script&lang=js&"
export * from "./NewsCatalogBlock.vue?vue&type=script&lang=js&"
import style0 from "./NewsCatalogBlock.vue?vue&type=style&index=0&id=51800e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51800e10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51800e10')) {
      api.createRecord('51800e10', component.options)
    } else {
      api.reload('51800e10', component.options)
    }
    module.hot.accept("./NewsCatalogBlock.vue?vue&type=template&id=51800e10&scoped=true&", function () {
      api.rerender('51800e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/NewsCatalogBlock.vue"
export default component.exports